import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tickbig",
  "use": "icon-tickbig-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-tickbig\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<polygon points=\"6.46 10.58 5 12 10.16 17.02 19 8.4 17.54 6.98 10.16 14.18 6.46 10.58\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol